var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 2H10.8205C10.4005 0.84 9.30049 0 8.00049 0C6.70049 0 5.60049 0.84 5.18049 2H2.00049C0.900488 2 0.000488281 2.9 0.000488281 4V19C0.000488281 20.1 0.900488 21 2.00049 21H8.11049C7.52049 20.43 7.04049 19.75 6.69049 19H2.00049V4H4.00049V5C4.00049 6.1 4.90049 7 6.00049 7H10.0005C11.1005 7 12.0005 6.1 12.0005 5V4H14.0005V9.08C14.7105 9.18 15.3805 9.39 16.0005 9.68V4C16.0005 2.9 15.1005 2 14.0005 2ZM8.00049 4C7.45049 4 7.00049 3.55 7.00049 3C7.00049 2.45 7.45049 2 8.00049 2C8.55049 2 9.00049 2.45 9.00049 3C9.00049 3.55 8.55049 4 8.00049 4ZM13.0005 11C10.2405 11 8.00049 13.24 8.00049 16C8.00049 18.76 10.2405 21 13.0005 21C15.7605 21 18.0005 18.76 18.0005 16C18.0005 13.24 15.7605 11 13.0005 11ZM14.2905 18L12.6405 16.35C12.5505 16.26 12.4905 16.13 12.4905 16V13.51C12.4905 13.23 12.7105 13.01 12.9905 13.01C13.2705 13.01 13.4905 13.23 13.4905 13.51V15.8L14.9905 17.3C15.1905 17.5 15.1905 17.81 14.9905 18.01C14.8005 18.2 14.4905 18.2 14.2905 18Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/Application.186cfab3cf369b0acbee92eb75abc410.svg";
export { ForwardRef as ReactComponent };